module.exports = __webpack_public_path__ + "kaman-0a36ea901588c42303e384c26ffd3365.webp";